import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';
import Settings from '@/components/Settings';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: { requiresAuth: true },
    },
    {
      path: '/create',
      name: 'Create',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id',
      name: 'Form-details',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/entries',
      name: 'Form-entries',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/entries/:entryId',
      name: 'Form-entries-entryId',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/edit',
      name: 'Form-edit',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/html',
      name: 'Form-html',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: '/auth/login',
      name: 'Login',
      component: Login,
    },
    { path: '*', redirect: '404.html' },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth
    && !store.state.isUserLoggedIn)) next({ path: '/auth/login' });

  else next();
});

export default router;
